var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.6667 5.33334V3.00044C10.6667 2.44595 10.6667 2.1687 10.5499 1.99832C10.4478 1.84946 10.2898 1.74834 10.1118 1.71806C9.90819 1.68341 9.65646 1.79959 9.153 2.03195L3.23934 4.76134C2.79034 4.96857 2.56583 5.07219 2.4014 5.23289C2.25604 5.37495 2.14508 5.54837 2.077 5.73989C2 5.95653 2 6.20379 2 6.69832V10M11 9.66667H11.0067M2 7.46667L2 11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27316 13.5229 2.47713 13.7269 2.72801 13.8547C3.01323 14 3.3866 14 4.13333 14H11.8667C12.6134 14 12.9868 14 13.272 13.8547C13.5229 13.7269 13.7268 13.5229 13.8547 13.272C14 12.9868 14 12.6134 14 11.8667V7.46667C14 6.71994 14 6.34657 13.8547 6.06135C13.7268 5.81047 13.5229 5.6065 13.272 5.47867C12.9868 5.33334 12.6134 5.33334 11.8667 5.33334L4.13333 5.33334C3.3866 5.33334 3.01323 5.33334 2.72801 5.47867C2.47713 5.6065 2.27316 5.81047 2.14532 6.06135C2 6.34657 2 6.71994 2 7.46667ZM11.3333 9.66667C11.3333 9.85077 11.1841 10 11 10C10.8159 10 10.6667 9.85077 10.6667 9.66667C10.6667 9.48258 10.8159 9.33334 11 9.33334C11.1841 9.33334 11.3333 9.48258 11.3333 9.66667Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet02);
export default __webpack_public_path__ + "a2ac6764891a58493f9877a71c3e7a9a.svg";
export { ForwardRef as ReactComponent };